module.exports = __webpack_public_path__ + "static/step3-element-4a97654be1877086b3592375c3e87099.png";